export function formatDate(iso: string): string {
  return iso.slice(0, 10).replaceAll('-', '.')
}
